import React, { useEffect, useState } from "react";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { receiptStepState } from "../../recoil/pageStep";
import Survey from "./Survey";
import CompleteConfirm from "./CompleteConfirm";
import InfoInsert from "./InfoInsert";
import AgreeInsert from "./AgreeInsert";
import ReceiptStartPage from "./ReceiptStartPage";
import { useForm } from "react-hook-form";
import {
  firstAnswerState,
  firstReceiptFormState,
  receiptSubmitState,
  secondAnswerState,
  signFileState,
  thirdAnswerState,
} from "../../recoil/receipt";
import useReceiptActions from "../../api/hooks/receipt";
import { logoURL } from "./ApplyRouter";
import useExamActions from "../../api/hooks/exam";
import ErrorPageGroupId from "./ErrorPageGroupId";
import { useMutation } from "@tanstack/react-query";

export const ReceiptStep = {
  APPLY_START_PAGE: 0,
  INFO_INSERT: 1,
  AGREE_INSERT: 2,
  // SURVEY: 3,
  SURVEY_DONE: 4,
  GROUP_ID_ERROR: 5,
};

const ReceiptRouter = () => {
  const { apply } = useReceiptActions();
  const [receiptStep, setReceiptStep] = useRecoilState(receiptStepState);
  const firstReceiptForm = useRecoilValue(firstReceiptFormState);
  const signFile = useRecoilValue(signFileState);
  const firstSurveyAnswer = useRecoilValue(firstAnswerState);
  const secondSurveyAnswer = useRecoilValue(secondAnswerState);
  const thirdSurveyAnswer = useRecoilValue(thirdAnswerState);

  const examActions = useExamActions();
  const [isLogo, setLogo] = useState();

  const [isErrorCheck, setErrorCheck] = useState(false);

  const [submitState, setSubmitState] = useRecoilState(receiptSubmitState);

  const {
    handleSubmit,
    formState: { errors },
  } = useForm();

  // const getGroupLogo = async () => {
  //   const url = new URL(window.location.href);

  //   const urlParams = url.searchParams;

  //   console.log("groudId :", urlParams.get("groupId"));

  //   const res = await examActions.getGroupLogo({
  //     groupId: urlParams.get("groupId"),
  //   });

  //   console.log("res :", res);
  //   logoURL.uuid = urlParams.get("groupId");

  //   if (res.status === 200) {
  //     console.log("awe");
  //     let hostURL = "https://" + window.location.host;

  //     if (hostURL.includes("localhost")) {
  //       hostURL = "https://opic.airsoundtest.com";
  //     }

  //     logoURL.logo = hostURL + res.data.url;
  //     logoURL.title = res.data.title + " ";

  //     console.log("logoURL.logo :", logoURL.logo);

  //     setLogo(true);
  //   } else {
  //     setErrorCheck(true);
  //   }
  // };

  // getGroupLogo();

  useEffect(() => {}, [isLogo]);

  const mutation = useMutation(apply, {
    onSuccess: () => {
      alert("접수에 성공했습니다.");
      setReceiptStep(4);
      // Invalidate and refetch
    },
    onError: () => {
      alert("접수를 실패했습니다.");
      setSubmitState(true);
    },
  });

  const onSubmit = async (data) => {
    setSubmitState(false);
    if (submitState) {
      const req = {
        ...firstReceiptForm,
        // signature: signFile,
        // device: window.navigator.userAgent.toLowerCase(),
      };

      mutation.mutate(req);
    } else {
      alert("이미 접수 신청 중입니다.");
    }
  };

  // if (isErrorCheck) {
  //   return (
  //     <>
  //       <ErrorPageGroupId />
  //     </>
  //   );
  // }

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <ReceiptStartPage
          visibility={receiptStep === ReceiptStep.APPLY_START_PAGE || "none"}
        />
        <InfoInsert
          visibility={receiptStep === ReceiptStep.INFO_INSERT || "none"}
        />
        <AgreeInsert
          visibility={receiptStep === ReceiptStep.AGREE_INSERT || "none"}
        />
        <Survey visibility={receiptStep === ReceiptStep.SURVEY || "none"} />
        <CompleteConfirm
          visibility={receiptStep === ReceiptStep.SURVEY_DONE || "none"}
        />
      </form>
    </>
  );
};

export default ReceiptRouter;
